/**
 * Constants for the company stage strategy
 */

// Predefined company stage options
export const COMPANY_STAGES = {
  // Current Company Stage options
  CURRENT_EARLY: { 
    label: 'Current: Early Stage', 
    category: 'CURRENT',
    value: 'early',
    displayText: 'Current: Early Stage' 
  },
  CURRENT_MID: { 
    label: 'Current: Mid Stage', 
    category: 'CURRENT',
    value: 'mid',
    displayText: 'Current: Mid Stage' 
  },
  CURRENT_LATE: { 
    label: 'Current: Late Stage', 
    category: 'CURRENT',
    value: 'late',
    displayText: 'Current: Late Stage' 
  },
  CURRENT_PUBLIC: { 
    label: 'Current: Public', 
    category: 'CURRENT',
    value: 'public',
    displayText: 'Current: Public' 
  },
  
  // Recent Company Stage options
  RECENT_EARLY: { 
    label: 'Recent: Early Stage', 
    category: 'RECENT',
    value: 'early',
    displayText: 'Recent: Early Stage' 
  },
  RECENT_MID: { 
    label: 'Recent: Mid Stage', 
    category: 'RECENT',
    value: 'mid',
    displayText: 'Recent: Mid Stage' 
  },
  RECENT_LATE: { 
    label: 'Recent: Late Stage', 
    category: 'RECENT',
    value: 'late',
    displayText: 'Recent: Late Stage' 
  },
  RECENT_PUBLIC: { 
    label: 'Recent: Public', 
    category: 'RECENT',
    value: 'public',
    displayText: 'Recent: Public' 
  },
  
  // Past Company Stage options
  PAST_EARLY: { 
    label: 'Past: Early Stage', 
    category: 'PAST',
    value: 'early',
    displayText: 'Past: Early Stage' 
  },
  PAST_MID: { 
    label: 'Past: Mid Stage', 
    category: 'PAST',
    value: 'mid',
    displayText: 'Past: Mid Stage' 
  },
  PAST_LATE: { 
    label: 'Past: Late Stage', 
    category: 'PAST',
    value: 'late',
    displayText: 'Past: Late Stage' 
  },
  PAST_PUBLIC: { 
    label: 'Past: Public', 
    category: 'PAST',
    value: 'public',
    displayText: 'Past: Public' 
  }
};

// Company stage categories for grouping
export const COMPANY_STAGE_CATEGORIES = {
  CURRENT: { 
    label: 'Current Company Stage',
    description: 'The stage of the company where the candidate currently works'
  },
  RECENT: { 
    label: 'Recent Company Stage',
    description: 'The stage of the company where the candidate recently worked'
  },
  PAST: { 
    label: 'Past Company Stage',
    description: 'The stage of the company where the candidate worked in the past'
  }
};
